













































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { vxm } from './../store.vuex';
import Avatar from 'vue-avatar';
import { UserProfile } from '../models/userdata/profile';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import {
  stepNameTextMapping,
  NEW_PROFILE_SECTION_KEY_MAPPER,
} from '@/models/configs/ProfileConstants';
import { GSU_STEP_NAME_MAPPER } from '@/components/GuidedSignup/GSUConstants';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});

@Component({
  name: 'Jobseeker',
  components: {
    Avatar,
  },
})
export default class Jobseeker extends Vue {
  $wlToastr: any;
  private userProfile: UserProfile = new UserProfile();
  private showSaveAndEditOption: boolean = false;
  private showProfileWizardLink = false;
  private selectedFileUrl = '';
  private sections: Array<string> = [];

  private ALIAS_TO_SECTION_KEY_MAPPER = {
    findJobs: 'FIND_JOBS',
    referafriend: 'REFER_A_FRIEND',
    myJobs: 'MY_JOBS',
    myReferrals: 'MY_REFERRALS',
    job_alerts: 'JOB_ALERTS',
    savedJobs: 'SAVED_JOBS',
    chat: 'INBOX',
  };

  @Watch('professionalReferenceList')
  onUpdateProfessionalReferenceList() {
    vxm.users.getProfileWizardMissingStepEstimate();
  }

  @Watch('updatedSkillTypes')
  onUpdateSkillTypes() {
    vxm.users.getProfileWizardMissingStepEstimate();
  }

  @Watch('resumeListing')
  onChangeResumeListing() {
    vxm.users.getProfileWizardMissingStepEstimate();
  }

  get professionalReferenceList() {
    return vxm.users.ProfessionalReferenceList;
  }

  get updatedSkillTypes() {
    return vxm.users.myUserProfile.skillTypes;
  }

  get useAlternativeColor() {
    return vxm.configs.getGlobalConfigValue('USE_ALTERNATIVE_PROFILE_WIDGET_COLOR')
  }

  get resumeListing() {
    return vxm.jobs.resumeListing;
  }

  get stepNameTextMapping() {
    return (step) => {
      const stepName = stepNameTextMapping(step);
      //if (stepName) return stepName;
      //const wizardStep =
      //  vxm.configs.ClientConfigs.profileWizardConfig.profileSections.find(
      //    (section) => section.sectionKey === step,
      //  );
      //return wizardStep ? wizardStep.displayName : step;
      return this.getSectioni18Title(step, stepName);
    };
  }

  getSectioni18Title(sectionKey: string, defaultText: string) {
    let normalizedKey = this.getNormalizedi18Key(sectionKey);
    const label = this.$t(`profile-accordion.${normalizedKey}`).toString();
    return label.indexOf('profile-accordion') >= 0 ? defaultText : label;
  }

  getNormalizedi18Key(sectionKey: string) {
    if (vxm.configs.IsConfigJSONEnabled) {
      return sectionKey.toLowerCase();
    } else {
      sectionKey = sectionKey.toLowerCase();
      return NEW_PROFILE_SECTION_KEY_MAPPER[sectionKey]
        ? NEW_PROFILE_SECTION_KEY_MAPPER[sectionKey].toLowerCase()
        : sectionKey;
    }
  }

  get TotalCompletionEstimate() {
    if(vxm.users.MissingStepsEstimateInfo && vxm.users.MissingStepsEstimateInfo.totalCompletionEstimate &&
      vxm.users.MissingStepsEstimateInfo.missingSteps.find(step => step.completionEstimate != null && step.completionEstimate != '')
    ) {
      return vxm.users.MissingStepsEstimateInfo.totalCompletionEstimate;
    }
    return '';
  }

  getWizardSection(sectionKey: string) {
    return vxm.configs.ClientConfigs.profileWizardConfig.profileSections.find(
      (section) => section.sectionKey === sectionKey,
    );
  }

  get MissingStepsEstimateInfo () {
    if(vxm.users.MissingStepsEstimateInfo && vxm.users.MissingStepsEstimateInfo.missingSteps) {
      return vxm.users.MissingStepsEstimateInfo.missingSteps;
    }
    return [];
  }

  get requiredStepsHeader() {
    return this.$tc(
      'profile-wizard-button.requiredStepHeader',
      this.MissingStepsEstimateInfo.length,
    );
  }

  get requiredStepsMessage() {
    return this.MissingStepsEstimateInfo.length
      ? this.$t('profile-wizard-button.requiredStepIncompleteMessage')
      : this.$t('profile-wizard-button.requiredStepCompletedMessage');
  }

  get completedStepsPercentage() {
    if (!this.requiredStepsInfo.stepsRequired.length) return 0;
    return this.missingStepCount / this.requiredStepsInfo.stepsRequired.length * 100 ;
  }

  get missingStepCount() {
    if(!this.requiredStepsInfo.stepsRequired.length) return 0;
    return this.requiredStepsInfo.stepsRequired.length - this.MissingStepsEstimateInfo.length;
  }

  get percentComplete() {
    console.log(
      'profile strangth:' + vxm.users.myUserProfile.userProfileStrength,
    );
    return vxm.users.myUserProfile.userProfileStrength;
  }

  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }

  get enableProfilePicture() {
    return !vxm.configs.getGlobalConfigBooelanValue(
      'CANDIDATE_PORTAL_UPLOAD_PROFILE_PICTURE_DISABLED',
    );
  }

  get FullName() {
    return (
      vxm.users.myUserProfile.firstName + ' ' + vxm.users.myUserProfile.lastName
    );
  }

  onFileChange(e) {
    let vm = this;
    const file = e.target.files[0];
    vm.userProfile.profilePictureFile = file;
    this.selectedFileUrl = URL.createObjectURL(file);
    vm.showSaveAndEditOption = true;
    this.$modal.hide('upload-profile-pic-modal');
  }

  showModalUploadModal() {
    this.$modal.show('upload-profile-pic-modal');
  }
  hideUploadModalModal() {
    this.$modal.hide('upload-profile-pic-modal');
  }

  validateUserProfilePicFileFormat() {
    let vm = this;
    let response = false;
    console.log('userProfile ', vm.userProfile);
    const ext = vm.userProfile.profilePictureFile.name.match(/\.([^\.]+)$/)[1];
    const fileNameFormat =
      vm.userProfile.profilePictureFile.name.match(/\.([^\.]+)$/)[0];
    switch (ext) {
      case 'png':
      case 'jpeg':
      case 'jpg':
      case 'PNG':
        break;
      default:
        console.log('Not allowed');
        response = true;
        vm.$wlToastr(
          'error',
          fileNameFormat +
            ' is an unsupported file format. Following file formats are allowed: .png, .jpeg',
          'Profile Picture',
        );
    }
    return response;
  }
  saveUserProfilePic() {
    let vm = this;
    if (vm.validateUserProfilePicFileFormat()) {
      return;
    }
    if (vm.userProfile.profilePictureFile.size >= 2097152) {
      //10485760 , 2097152
      console.log(
        'file size - ' + vm.userProfile.profilePictureFile.size + ' in bytes',
      );
      vm.$wlToastr('error', 'File size cannot exceed 2 mb', 'Profile Picture');
      return;
    }
    const respPromise: any = vxm.users.saveProfilePicture(vm.userProfile);
    Promise.all([respPromise])
      .then((values) => {
        if (values[0]) {
          if (values[0].success) {
            const resp: any = vxm.users.refreshProfileInfo();
            Promise.all([resp]).then((values) => {
              if (values[0]) {
                vm.showSaveAndEditOption = false;
                vm.userProfile.profilePictureFile = null;
                vm.$wlToastr(
                  'success',
                  this.$t('profile-pic-upload-success-message'),
                  'Profile Picture',
                );
                this.selectedFileUrl = '';
              }
            });
          } else {
            vm.$wlToastr('error', values[0].errorMessage, 'Profile Picture');
          }
        }
      })
      .catch((e) => {
        if (
          e &&
          e.response &&
          (e.response.status === 503 || e.response.status === 418)
        ) {
          this.$wlToastr(
            'error',
            this.$t('ResumeDetails_SecurityRisk'),
          );
        }
      });
  }

  cancelSaveProfilePic() {
    console.log('userProfile ', this.userProfile);
    this.userProfile.profilePictureFile = null;
    this.showSaveAndEditOption = false;
    this.selectedFileUrl = '';
  }

  get uploadProfileFileUrl() {
    if (
      vxm.users.myUserProfile.userProfileBasePath &&
      vxm.users.myUserProfile.profilePicGUID
    ) {
      return (
        vxm.users.myUserProfile.userProfileBasePath +
        vxm.users.myUserProfile.profilePicGUID +
        '.' +
        vxm.users.myUserProfile.profilePicExtType
      );
    }
    return '';
  }

  async mounted() {
    if (vxm.users.isLoggedIn) {
      //vxm.users.refreshProfileInfo();
      await vxm.users.getProfileWizardStepInfo();
      await vxm.users.getProfileWizardMissingStepEstimate();
      if (!vxm.configs.IsConfigJSONEnabled) {
        await vxm.users.fetchWizardSteps();
      }
      const path = this.$route.path.replace('/myprofile/v2/', '');
      if (path === 'details') {
        return;
      }
      const element: any =
        this.$parent.$refs[this.$route.path.replace('/myprofile/v2/', '')];
      element &&
        element[0].scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        });
    }
  }

  get requiredStepsInfo() {
    return vxm.users.RequiredStepsInfo;
  }
}
